import { render } from "./Gameboard_Story_Window.vue?vue&type=template&id=c7057fcc"
import script from "./Gameboard_Story_Window.vue?vue&type=script&lang=js"
export * from "./Gameboard_Story_Window.vue?vue&type=script&lang=js"

import "./Gameboard_Story_Window.vue?vue&type=style&index=0&id=c7057fcc&lang=scss"
script.render = render

export default script